document.addEventListener('livewire:init', function () {
  Livewire.on('rejectionReason.confirmSnagRejection', () => {
    if (confirm('Are you sure you want to reject this snag? The given reason will be visible to the customer.')) {
      Livewire.dispatch('rejectionReason.confirmedSnagRejection');
    } else {
      Livewire.dispatch('rejectionReason.cancelSnagRejection');
    }
  });
});
